<template>
  <touch-layout>
    <template #header_page_breadcrumb>
      <slot name="header_page_breadcrumb" />
    </template>
    <template #header_page_title>
      <slot name="header_page_title" />
    </template>
    <slot name="menu" />
    <loading
      :loading="false"
      class="bg-gray-200 w-full h-full overflow-y-auto  overflow-x-hidden"
    >
      <ManageProductGroups />
    </loading>
  </touch-layout>
</template>

<script>
import ManageProductGroups from '@/components/business/productSetup/ManageProductGroups.vue';

export default {
  components: {
    ManageProductGroups,
  },
};
</script>
